const THOUSANDS_GROUPED = /^-?\d{1,3}(\.\d{3})+$/;
const PLAIN_DECIMAL = /^-?\d+(\.\d+)?$/;

/**
 * Reads a number typed the Argentine way: "," for decimals and "." for
 * thousands ("1.500,50"). A lone "." is a decimal point ("1500.50") unless it
 * splits groups of exactly three digits ("1.500" is fifteen hundred).
 * Anything ambiguous or malformed is `null`, never a silently wrong amount.
 */
export function parseDecimal(input: string): number | null {
  const value = input.trim();

  if (value === '') {
    return null;
  }

  if (value.includes(',')) {
    const [integer, decimals, ...rest] = value.split(',');

    if (rest.length > 0 || integer === undefined || decimals === undefined || !/^\d+$/.test(decimals)) {
      return null;
    }

    const digits = integer.includes('.') ? (THOUSANDS_GROUPED.test(integer) ? integer.replaceAll('.', '') : null) : integer;

    if (digits === null || !/^-?\d+$/.test(digits)) {
      return null;
    }

    return Number(`${digits}.${decimals}`);
  }

  if (THOUSANDS_GROUPED.test(value)) {
    return Number(value.replaceAll('.', ''));
  }

  return PLAIN_DECIMAL.test(value) ? Number(value) : null;
}
